import * as angular from 'angular';
import * as $ from 'jquery';

import { ExportConfigurationViewModel } from '../ExportConfigurationViewModel';
import { ComponentDefinition } from '../../../../models';
import { ILoggerService } from '../../../../services';

class ConfigurationListController implements angular.IComponentController {
    selected: ExportConfigurationViewModel;

    readonly configurations: ExportConfigurationViewModel[];
    readonly delete: () => void;
    readonly duplicate: (configuration: any) => void;
    readonly formController: angular.IFormController;
    readonly isEditMode: boolean;
    readonly isLoading: boolean;
    readonly loadingMessage: string;
    
    static $inject = ['loggerService'];

    constructor(private _loggerService: ILoggerService) {
    }

    select(configuration: ExportConfigurationViewModel, $event: angular.IAngularEvent) {
        if (this.formController && this.formController.$dirty) {
            this._loggerService
                .logWarning('There are pending changes. Save or cancel before selecting another item.');
        }
        else {
            this.selected = configuration;
        }
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        $event.stopPropagation();
    }

    tryDelete(configuration: ExportConfigurationViewModel, $event: angular.IAngularEvent): void {
        this.selected = configuration;
        $('#confirmDeleteConfiguration').modal('show');
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        $event.stopPropagation();
    }

    tryDuplicate(configuration: ExportConfigurationViewModel, $event: angular.IAngularEvent): void {
        this.select(configuration, $event);
        if (this.duplicate) {
            this.duplicate({ configuration });
        }
    }
}

export const configurationList: ComponentDefinition = {
    componentId: 'wtConfigurationList',
    controller: ConfigurationListController,
    template: require('./configurationList.component.html'),
    controllerAs: 'vm',
    bindings: {
        configurations: '<',
        delete: '&?',
        duplicate: '&?',
        formController: '<',
        isEditMode: '<?',
        isLoading: '<',
        loadingMessage: '<',
        selected: '='
    }
};
